// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"51d3a2ed","741":"c16cb297","787":"77b99338"}[chunkId] + ".chunk.js";
};